import { MenuItem, Select as MSelect } from "@mui/material";
import { useEffect, useState } from "react";

const dropdownImg =
  "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e";

const Select = ({
  classNames = {
    rootContainer: "",
    label: "",
    select: "",
  },
  label,
  placeholder = "Select",
  multiple = false,
  options = [],
  errorMessage,
  value = "",
  onChange = () => {},
  onValueChange = () => {},
}) => {
  const [selection, setSelection] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelection(typeof value === "string" ? value.split(",") : value);

    onChange(event);
    onValueChange(value);
  };

  useEffect(() => {
    if (multiple) {
      setSelection(value || []);
    } else {
      setSelection(value);
    }
  }, [value, multiple]);

  return (
    <div className={`CT-select ${classNames.rootContainer}`}>
      {label && <label className={classNames.label}>{label}</label>}

      <MSelect
        className={classNames.select}
        value={selection}
        onChange={handleChange}
        fullWidth
        multiple={multiple}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span>{placeholder}</span>;
          }

          return options
            .filter((option) =>
              multiple
                ? selected.includes(option.value)
                : selected === option.value,
            )
            .map((option) => option.label)
            .join(", ");
        }}
        IconComponent={() => (
          <img
            src={dropdownImg}
            height={12}
            className="position-absolute"
            style={{ right: "14px" }}
          />
        )}
        sx={{
          height: "43px",
          borderRadius: "40px",
          fontSize: "14px",
          color: "#404040",
          backgroundColor: "#fff",
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value} label={option.label}>
            {option.label}
          </MenuItem>
        ))}
        {!options.length ? (
          <MenuItem className="justify-content-center" value="no_option" disabled>No options available</MenuItem>
        ) : null}
      </MSelect>
      {errorMessage && <span className="errorMessage">{errorMessage}</span>}
    </div>
  );
};

export default Select;
